import { KAddressFormBox, KForm, KPhoneField, KTextField } from "kinnect-general";

export default KForm.extend( {
	name: "AddressForm",

	props: {
		address: Object,
		idCustomer: Number
	},

	data: () => ( {
		formFields: {
			address: null,
			alias: null,
			city: null,
			idCustomer: null,
			lat: null,
			lng: null,
			phone: null,
			state: null,
			zip: null
		}
	} ),

	computed: {
		editing() {
			return Boolean( this.address );
		},

		formUrl() {
			return this.editing
				? `addresses/${this.address.id}`
				: "addresses";
		},

		internalRedirect() {
			if ( this.redirect ) {
				return this.redirect;
			}

			if ( this.idCustomer ) {
				return [ "back", {
					name: "customer",
					params: { idCustomer: this.idCustomer }
				} ];
			}

			return [ "back", { name: "front" } ];
		}
	},

	watch: {
		address: {
			handler( address ) {
				if ( address ) {
					Object.keys( this.formFields ).forEach( key => {
						if ( address.hasOwnProperty( key ) ) {
							this.formFields[key] = address[key];
						}
					} );
				}
			},
			immediate: true
		},

		idCustomer: {
			handler( val ) {
				this.formFields.idCustomer = val;
			},
			immediate: true
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: this.formUrl,
				data: this.formFields,
				method: this.editing ? "put" : "post",
				on: this.$listeners,
				redirect: this.internalRedirect
			}}
			on={this.$listeners}
		>
			<KTextField
				class="ml-blank-icon"
				hint="A nickname for this address"
				label="Alias*"
				required
				vModel={this.formFields.alias}
				validationName="alias"
				validationRules="required"
			></KTextField>

			<KPhoneField
				label="Phone Number"
				vModel={this.formFields.phone}
				validationName="phone"
				validationRules="phone"
			></KPhoneField>

			<KAddressFormBox
				address={this.formFields.address}
				city={this.formFields.city}
				class="ml-blank-icon mt-2"
				lat={this.formFields.lat}
				lng={this.formFields.lng}
				on={{
					"update:address": val => this.formFields.address = val,
					"update:city": val => this.formFields.city = val,
					"update:lat": val => this.formFields.lat = val,
					"update:lng": val => this.formFields.lng = val,
					"update:state": val => this.formFields.state = val,
					"update:zip": val => this.formFields.zip = val
				}}
				required
				state={this.formFields.state}
				zip={this.formFields.zip}
			></KAddressFormBox>
		</KForm>;
	}
} );
